import * as React from 'react';
import { Props } from 'react';

import { capitalizeFirstLetter } from '../../../lib/utils';

import '../../RegistrationAuthorization/RegistrationAuthorization.scss';
import i18next from 'i18next';

interface SuccessViewProps extends Props<SuccessView> {
    channelId: string;
    onOk: () => any;
}

export class SuccessView extends React.Component<SuccessViewProps> {
    render() {
        const {onOk, channelId} = this.props;
        return (
            <div className={`authorization-container ${channelId}`}>
                <div className={`authorization ${channelId}`}>
                    <div className={`auth-tab ${channelId}`}>
                        <div className={`reg-success-title reg-success-title-${channelId}`}>
                            {i18next.t('registration')}
                        </div>
                    </div>
                    <div className='auth-body'>
                        <div className='auth-body-title' style={{fontSize: '14px'}}>
                            {i18next.t('thanks_for_registration')}<br/>
                            <div
                                dangerouslySetInnerHTML={{
                                    __html: i18next.t('come_back_to_messenger', {
                                        come_back: channelId === 'whatsapp'
                                            ? `<a href='https://wa.me/74997531065'>${i18next.t('come_back_to_whatsapp')}</a>`
                                            : `${i18next.t('come_back_to')} ${capitalizeFirstLetter(channelId)}`
                                    })}}
                            />
                        </div>
                    </div>

                    <div>    
                        <div className='auth-button-container'>
                            <div className={`auth-button ${channelId}`} onClick={() => onOk()}>
                                {i18next.t('ok')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Registration/Success/SuccessView.tsx